export default __webpack_public_path__ + "static/media/umamgr-hover.f49f3fd1.svg";